import { LoginPage } from "@/modules/auth/pages/LoginPage";
import { LandingPage } from "@/modules/landing/pages/LandingPage";
import { SandboxPage } from "@/modules/sandbox/pages/SandboxPage";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router";
import { AuthInitializer } from "@/modules/auth/components/AuthInitializer";
import { FeaturebaseRoot } from "@/modules/feedback/components/FeaturebaseProvider";
import "./app/globals.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <AuthInitializer>
      <FeaturebaseRoot>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/spaces/:slug" element={<SandboxPage />} />
            <Route path="/login" element={<LoginPage />} />
          </Routes>
        </BrowserRouter>
      </FeaturebaseRoot>
    </AuthInitializer>
  </StrictMode>,
);
